import NoImage from "../../images/no_image.jpg";

export const adjustThumbnail = (url?: string) => `${url || NoImage}`;

export const getCssUrl = (url?: string) => `url(${adjustThumbnail(url)})`;
